/**
 * Which functional modules are SHOWN right now. Everything the client has not yet
 * reviewed and approved against the v2.0 package is hidden — not deleted: the screens,
 * routes and API stay in the codebase and come back by flipping a flag here.
 *
 * Approved so far: design language, roles, permissions (Users, Settings, Agents), Clients.
 * Hidden until their stage is agreed: dashboard, orders, products, reports, payments — and
 * the agent portal's order screens; the agent's own clients and settings are shown.
 */
/** Dev-only: `VITE_SHOW_ALL_MODULES=1` shows every module (screenshots, review builds). */
const SHOW_ALL = import.meta.env.VITE_SHOW_ALL_MODULES === '1';

export const MODULES = {
  dashboard: SHOW_ALL,
  orders: SHOW_ALL,
  clients: true,
  products: SHOW_ALL,
  reports: SHOW_ALL,
  payments: SHOW_ALL,
  agents: true,
  users: true,
  settings: true,
  /** The agent portal's own screens (home, orders, clients, products). */
  agentPortal: SHOW_ALL,
} as const;

export type ModuleKey = keyof typeof MODULES;

export function isModuleEnabled(key: ModuleKey | undefined): boolean {
  return key === undefined ? true : MODULES[key];
}
